import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledListAppDetailContainer = styled('div')`
  .list-app-detail-card {
    margin: 16px 4px;
    min-height: 100vh;
    width: 100%;
  }

  .list-app-detail-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1135px;
    margin: 0 auto;
  }
  .container {
    display: flex;
    flex-direction: column;
    padding: 24px;
    padding-bottom: 40px;

    @media only screen and (max-width: 768px) {
      padding: 16px;
    }
  }

  @media only screen and (max-width: 768px) {
    .info-detail-app {
      display: flex;
      flex-direction: column !important;
      gap: 12px !important;
    }

    .general-info-container {
      padding: 16px;
      border: 0.5px solid #1e164e29;
      border-radius: 16px;
      margin-top: 12px;
    }
  }

  .generalDetail {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-top: 12px;
    padding-bottom: 16px;

    @media only screen and (max-width: 926px) {
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
    }

    @media only screen and (max-width: 768px) {
      padding-top: 0px;
    }
  }

  /* New layout (feature flag ON): label on top, value below */
  .generalDetail-new {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 40px;
    padding-top: 12px;
    padding-bottom: 16px;

    @media only screen and (max-width: 926px) {
      flex-direction: column;
      gap: 12px;
    }

    @media only screen and (max-width: 768px) {
      padding-top: 0px;
    }
  }

  .info-col {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;

    &--name {
      flex: 1;
      min-width: 0;
    }
  }

  .infoDetail {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: flex-end;

    @media only screen and (max-width: 926px) {
      justify-content: flex-start;
    }
  }
  .infoID {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media only screen and (max-width: 926px) {
      width: 100%;
    }
  }
  .token {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 16px;

    @media only screen and (max-width: 926px) {
      flex-direction: column;
      gap: 16px;
      align-items: flex-start;
    }
  }
  /* Legacy layout (feature flag OFF) */
  .summary-title {
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: 926px) {
      flex-direction: column;
      gap: 12px;
      align-items: flex-start !important;

      .summary-title-text {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  /* New layout (feature flag ON) */
  .summary-title-wrapper {
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media only screen and (max-width: 768px) {
      padding-left: 16px;
      padding-right: 16px;
    }

    .summary-title-header {
      display: flex;
      align-items: center;

      @media only screen and (max-width: 926px) {
        .summary-title-text {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }

  .summary-tabs-filter-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    @media only screen and (max-width: 926px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

export const StyledListAppDetailHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid ${COLOR.borderDropdown};

  .header-title {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media only screen and (max-width: 926px) {
    .app-detail-header-text {
      font-size: 16px;
      line-height: 24px;
    }
    border-bottom: none;
    padding-bottom: 0px;
    padding-left: 16px;
    padding-right: 16px;
  }

  @media only screen and (max-width: 600px) {
    .header-title {
      gap: 8px;
    }
  }
`;

export const StyledSummaryCard = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background: linear-gradient(
    135deg,
    #f8fafc 0%,
    rgba(239, 246, 255, 0.5) 50%,
    rgba(224, 231, 255, 0.8) 100%
  );
  border-radius: 16px;
  border: 0.5px solid #1e164e14;
  width: 100%;
  min-width: 236px;
  min-height: 140px;
  height: 100%;
  box-sizing: border-box;
  flex: 1 1 0;
  position: relative;

  .info-icon {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  @media only screen and (max-width: 1150px) {
    min-width: 230px;
  }
`;

export const StyledSummary = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(236px, 1fr));
  gap: 16px;
  width: 100%;
  padding: 24px;
  padding-top: 16px;
  box-sizing: border-box;
  @media only screen and (max-width: 1320px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 16px;
  }
`;

export const StyledUpdateAppActiveStatusDialogAction = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  @media only screen and (max-width: 600px) {
    width: 100%;
    justify-content: center;
    .button-1 {
      flex: 1;
      button {
        width: 100%;
      }
    }
  }
`;
